export default __webpack_public_path__ + "static/media/illustration-health-2-w.8c71def0.webp";